import moment from 'moment';
import { DayTime } from './types';

export function isDocumentUploadVisible(
  requireDocumentUpload: boolean = false,
  minAmountForDocumentUpload: number | null,
  requestedAmount?: number | null,
) {
  if (!requireDocumentUpload) {
    return false;
  }

  return (
    !minAmountForDocumentUpload ||
    (requestedAmount && requestedAmount >= minAmountForDocumentUpload)
  );
}

export function calculateDaysTimes(
  startDate: Date,
  endDate: Date,
  formValues: Record<string, any>,
): DayTime[] {
  const daysTimes: DayTime[] = [];
  const current = moment(startDate);
  const end = moment(endDate);

  while (current.isSameOrBefore(end, 'day')) {
    const date = current.format('YYYY-MM-DD');
    const start = formValues[`${date}_startTime`] || '09:00';
    const endT = formValues[`${date}_endTime`] || '17:00';
    daysTimes.push({
      currentDate: date,
      startTime: start,
      endTime: endT,
    });
    current.add(1, 'day');
  }

  return daysTimes;
}
